import ToolboxTextSettings from './ToolboxTextSettingsModal'
export default ToolboxTextSettings
